import { add, parseJSON } from 'date-fns';

declare global {
  interface Window {
    LegalNoticesClient: LegalNoticesClientLibrary;
  }
}

type LegalNoticesClientConstructor = new (config?: LegalNoticesClientConfig) => LegalNoticesClient;

interface LegalNoticesClientLibrary {
  LegalNoticesClient: LegalNoticesClientConstructor;
}

interface LegalNoticesClient {
  run(): void;
  showSettings(): void;
  setLanguageCode(code: string): void;
}

interface LegalNoticesClientConfig {
  languageCode: string;
}

(() => {
  if (window?.LegalNoticesClient == null) {
    console.warn('Legal notices client not loaded to window.LegalNoticesClient.')
    return;
  }

  const languageCode = document.getElementsByTagName('body')[0]?.getAttribute('data-langcode') ?? 'E';

  const client = new window.LegalNoticesClient.LegalNoticesClient({ languageCode });

  client.run();

  document.getElementById('lnkPrivacySettings')?.addEventListener('click', () => {
    client.showSettings();
  });
})();
